
<div>
<!--  <div-->
<!--    *ngIf="params?.enableMenu"-->
<!--    #menuButton-->
<!--    class="customHeaderMenuButton"-->
<!--    (click)="onMenuClicked($event)"-->
<!--  >-->
<!--    <i class="fa {{ params.menuIcon }}"></i>-->
<!--  </div>-->
  <div class="customHeaderLabel">{{ params.displayName }}</div>
  <!--  <div-->
  <!--    *ngIf="params.enableSorting"-->
  <!--    (click)="onSortRequested('asc', $event)"-->
  <!--    [ngClass]="ascSort!"-->
  <!--    class="customSortDownLabel">-->
  <!--    <i class="fa fa-long-arrow-alt-down"></i>-->
  <!--  </div>-->
  <!--  <div-->
  <!--    *ngIf="params.enableSorting"-->
  <!--    (click)="onSortRequested('desc', $event)"-->
  <!--    [ngClass]="descSort!"-->
  <!--    class="customSortUpLabel"-->
  <!--  >-->
  <!--    <i class="fa fa-long-arrow-alt-up"></i>-->
  <!--  </div>-->
  <!--  <div-->
  <!--    *ngIf="params.enableSorting"-->
  <!--    (click)="onSortRequested('', $event)"-->
  <!--    [ngClass]="noSort!"-->
  <!--    class="customSortRemoveLabel"-->
  <!--  >-->
  <i class="pi pi-times" (click)="remove()"></i>
<!--  <div-->
<!--    *ngIf="params.enableSorting"-->
<!--    (click)="onSortRequested('asc', $event)"-->
<!--    [ngClass]="ascSort!"-->
<!--    class="customSortDownLabel">-->
<!--    <i class="fa fa-long-arrow-alt-down"></i>-->
<!--  </div>-->
<!--  <div-->
<!--    *ngIf="params.enableSorting"-->
<!--    (click)="onSortRequested('desc', $event)"-->
<!--    [ngClass]="descSort!"-->
<!--    class="customSortUpLabel"-->
<!--  >-->
<!--    <i class="fa fa-long-arrow-alt-up"></i>-->
<!--  </div>-->
<!--  <div-->
<!--    *ngIf="params.enableSorting"-->
<!--    (click)="onSortRequested('', $event)"-->
<!--    [ngClass]="noSort!"-->
<!--    class="customSortRemoveLabel"-->
<!--  >-->

<!--  </div>-->
</div>
